// extracted by mini-css-extract-plugin
export default {"mainUiBlock":"YNsbh9","tooltipContainerWrapper":"O1vZ1d"};